<template>
    <div class="header">
        <img class="logo" src="https://hwysource.yunongyun.com/gwang/img/logo.png" alt="">
        <div class="nav">
            <div class="nav-item" v-for="(item, index) in navList" :key="index" :class="{'active': item.avtive}">
                <div @click="toLink(item)">{{item.name}}</div>
                <div class="line" v-if="item.avtive"></div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "pagehead",
    data() {
      return {
        navList: [{
          name: '首页',
          path: 'index'
        }, {
          name: '关于裕农',
          path: 'about'
        }, {
          name: '产品与服务',
          path: 'product'
        }, {
          name: '新闻中心',
          path: 'news'
        }, {
          name: '社会责任',
          path: 'social'
        }, {
          name: '诚聘英才',
          path: 'job'
        }, {
          name: '联系我们',
          path: 'contact'
        }]
      };
    },
    created() {
      this.navList.forEach((item, index) => {
        if (item.path == this.$route.name || item.path == this.$route.query.source) {
          this.$set(item, 'avtive', true)
        } else {
          this.$set(item, 'avtive', false)
        }
      })
    },
    methods: {
      toLink(data){
        this.$router.push({name: data.path})
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 72px;
    margin: 0 auto;
    .logo{
      width: 124px;
      height: 47px;
      margin-right: 100px;
    }
    .nav{
      display: flex;
      align-items: center;
      .nav-item{
        margin-right: 40px;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        color: rgba(0,0,0,0.6);
        cursor: pointer;
        position: relative;
        &.active{
          color: #0FBA6F;
        }
        .line{
          position: absolute;
          height: 2px;
          background: #0FBA6F;
          bottom: -24px;
          left: 0;
          right: 0;
          width: 100%;
        }
        &:hover{
          color: #0FBA6F;
        }
      }
    }
  
  }
  </style>